module.exports = __webpack_public_path__ + "img/Fee Collection.9d86748b.svg";